import { render, staticRenderFns } from "./alo-simple-pagination.vue?vue&type=template&id=08c8cf6a"
import script from "./alo-simple-pagination.vue?vue&type=script&lang=js"
export * from "./alo-simple-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports